import React from "react";
import { Link } from "react-router-dom";
import { TO_LOGIN } from "../../helpers/constants";
import "./auth-shell.scss";

export const AuthShell = ({ eyebrow, title, description, children, footer, compact = false }) => (
    <main className="auth-page">
        <div className={`auth-shell ${compact ? "compact" : ""}`}>
            <section className="auth-brand" aria-label="Intrepid Control Systems">
                <Link to={TO_LOGIN} className="auth-logo-link" aria-label="Intrepid Control Systems sign in">
                    <img src={require("../../assets/images/logo.png")} alt="Intrepid Control Systems" />
                </Link>
                <div>
                    <span>BlueSky</span>
                    <strong>Secure account access</strong>
                </div>
            </section>
            <section className="auth-panel">
                <header className="auth-heading">
                    {eyebrow && <span className="auth-eyebrow">{eyebrow}</span>}
                    <h1>{title}</h1>
                    {description && <p>{description}</p>}
                </header>
                {children}
                {footer && <footer className="auth-footer">{footer}</footer>}
            </section>
        </div>
    </main>
);

export const AuthField = ({ label, id, optional, error, ...inputProps }) => (
    <div className="auth-field">
        <label htmlFor={id}>{label}{optional && <span>Optional</span>}</label>
        <input id={id} className={error ? "is-invalid" : ""} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : undefined} {...inputProps} />
        {error && <div className="auth-field-error" id={`${id}-error`} role="alert">{error}</div>}
    </div>
);

export class PasswordField extends React.Component {
    state = { visible: false };

    render() {
        const { label, id, error, ...inputProps } = this.props;
        const errorId = error ? `${id}-error` : undefined;
        return (
            <div className="auth-field">
                <label htmlFor={id}>{label}</label>
                <div className="auth-password-wrap">
                    <input id={id} type={this.state.visible ? "text" : "password"} className={error ? "is-invalid" : ""} aria-invalid={Boolean(error)} aria-describedby={errorId} {...inputProps} />
                    <button type="button" onClick={() => this.setState((state) => ({ visible: !state.visible }))} aria-label={this.state.visible ? `Hide ${label.toLowerCase()}` : `Show ${label.toLowerCase()}`} aria-pressed={this.state.visible}>
                        <i className={`fa ${this.state.visible ? "fa-eye-slash" : "fa-eye"}`} aria-hidden="true"></i>
                    </button>
                </div>
                {error && <div className="auth-field-error" id={errorId} role="alert">{error}</div>}
            </div>
        );
    }
}

export const AuthStatus = ({ type = "info", icon, title, children }) => (
    <div className={`auth-status ${type}`} role={type === "error" ? "alert" : "status"}>
        <i className={`fa ${icon || (type === "error" ? "fa-exclamation-circle" : "fa-check-circle")}`} aria-hidden="true"></i>
        <h2>{title}</h2>
        {children}
    </div>
);
